import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { UToastComponent } from '@updater/angular-common';
import errorTemplate from '../errors/messages.html';
import { STATES } from '../../constants';

export default angular
  .module('app.state-config', [UToastComponent.name, uiRouter])
  .config(StateConfig)
  .run(StateRun);

function StateConfig($stateProvider) {
  const { host } = window.location;
  const proAppSignInHref = `//${host}/professionals/sign-in`;

  $stateProvider.state('app', {
    abstract: true,
    views: {
      header: {
        template: '<upd-app-header class="container"></upd-app-header>',
      },
      subheader: {
        template: `
          <div>
            <breadcrumb></breadcrumb>
            <app-alert></app-alert>
            <u-toast classes="u-animate" delay="15000"></u-toast>
          </div>
        `,
      },
      footer: {
        template: '<app-footer></app-footer>',
      },
      'error-messages': {
        template: errorTemplate,
      },
    },
  });

  $stateProvider.state(STATES.PRO_APP_SIGN_IN, {
    url: proAppSignInHref,
    data: {
      external: true,
    },
  });
}

function StateRun($rootScope, $window, uToast) {
  // Allow defining external `url`s for states. Though ui-router doesn't support them,
  // when using the `ui-sref` directive, external `url`s still renderer correct `href`s.
  $rootScope.$on('$stateChangeStart', (event, toState) => {
    if (toState.data && toState.data.external) {
      event.preventDefault();
      $window.open(toState.url, '_self');
    }
  });

  // Listen for all successful state changes and if a toast param is passed
  // then display that toast message (success or error). This allows us to
  // display a toast message after any page transition.
  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {
    handleToastMessage(toParams.toast);
  });

  // WARNING: This feature may not work as expected. Proceed with caution.
  // (The toast param could persist for all future state changes, at least child states).

  // Processes toast params in the format:
  //
  //   $state.go('state.name', {
  //     toast: {
  //       success: 'We successfully did something!',
  //       error:   'Oops... we messed up!'
  //     }
  //   })
  //
  function handleToastMessage(toast) {
    if (toast && Object.keys(toast).length) {
      for (let type of Object.keys(toast)) {
        uToast[type](toast[type]);
      }
    }
  }
}
